import { noop, setPaypalTotalPrice } from '../../../lib/utilities';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { handleView } from '../handle_view';
import { Cart } from '../../_flux/components/sidebar/cart';
import { showAction } from '../../_flux/actions/wheel_alignment_info_light_box_actions';
import { open } from '../../_modules/google_analytics/wheel_alignment_info_light_box';
import LightboxActions, {
    openAction as openCarFittingStationFinder,
    goToPageAction as goToFsfPage,
} from '../../_flux/actions/lightbox_actions';
import { showAction as openMotoFittingStationFinder } from '../../_flux/actions/fsf_moto_light_box_actions';
import ActiveStationStore from '../../_flux/stores/active_station_store';
import CartStore from '../../_flux/stores/cart_store';
import { ProductsStore } from '../../_flux/stores/products_store';
import { FittingStationStore } from '../../_flux/stores/fitting_station_store';
import { loadStations } from '../../_modules/fitting_station/load_stations';
import FittingStationFinderConstants from '../../_flux/constants/fitting_station_finder_constants';
import { fetchInitialStationAction } from '../../_flux/actions/active_station_actions';
import { updateAction as updateProduct } from '../../_flux/actions/products_actions';
import { types } from '../../_constants/product/types';
import { show } from '../../_flux/actions/postcode_light_box_actions';
import { show as showFriendbuyLightBox } from '../../_flux/actions/friendbuy_light_box_actions';
import { show as showProductDetails } from '../../_flux/actions/sidebar/light_box';
import { hideFsDetails, showFsDetails } from '../../_flux/actions/sidebar/general';
import { General } from '../../_flux/stores/sidebar/general';
import { getPriceForAll } from '../../_modules/product/get_price_for_all';
import { FsfPages } from '../../_constants/fsf_pages';
import onChangeStationClick from '../../_flux/components/sidebar/actions/on_change_station_click';
import onRemoveStationClick from '../../_flux/components/sidebar/actions/on_remove_station_click';
import isFSFDisabled from '../../_flux/helper/disable_fsf_for_store';
import onRemoveDiscount from '../../_flux/components/sidebar/actions/on_remove_discount_click';
import {
    showAction as lockUi,
    hideAction as unlockUi
} from '../../_flux/actions/ui_lock_actions';
import CartActions from '../../_flux/actions/cart_actions';
import { TotalPrice } from '../../_flux/components/sidebar/rows/total_price';
import Translation from '../../_flux/components/translation/translation';
import { GoToCheckout } from '../../_flux/components/sidebar/rows/go_to_checkout';
import { showAction as showFsfNotAvailableLightBox } from '../../_flux/actions/fsf_not_available_light_box_actions';
import { getMap } from '../../_flux/helper/gmap';
import { bind } from '../../_modules/function/bind';

import { loadGoogleMapDependencies } from '../../_global/initGoogleMapDependencies';

const stores = {
    activeStationState: ActiveStationStore,
    fittingStationState: FittingStationStore,
    productsState: ProductsStore,
    cartState: CartStore,
    sidebar: General
};

function render(
    {
        activeStationState,
        fittingStationState,
        productsState: products,
        cartState,
        sidebar,
    },
    options
) {
    if (cartState.cart.products) {
        products.forEach((pr, ind) => {
            const cartProduct = cartState.cart.products.find(cartPr => cartPr.spinach === pr.id);
            products[ind].productLinksTitles = cartProduct ? cartProduct.productLinksTitles : [];
            products[ind].cartProductType = cartProduct ? cartProduct.cartProductType : '';
            products[ind].isFittingAvailable = !!cartState?.checkout?.addressShipping?.shippingPostCode;
        });
    }

    let fittingNotAvailable = isFSFDisabled();
    for (let product of products) {
        if (product.type === types.WHEEL) {
            fittingNotAvailable = true;
        }
    }

    const { cart, checkout, customerDefaultAddress } = cartState;
    const { loadingPrices: loadingStationPrices } = fittingStationState;
    const { activeStation, wheelAlignment, initialLoading } = activeStationState;
    const [fittingStationStreet, fittingStationSuburb] = activeStation ? activeStation.address.split(', ') : [];
    const isMobileFitter = (checkout.addressShipping && checkout.addressShipping.fittingStation && checkout.addressShipping.fittingStation.isMobileFitter) || false;
    const fittingStationId = activeStation ? activeStation.id : '';
    const fittingPrice = activeStation ? activeStation.expenses.fitting : 0;
    const calloutFeePrice = activeStation && activeStation.calloutFeeRaw ? activeStation.calloutFeeRaw : 0;
    const wheelAlignmentQuantity = !activeStation ? 0 : wheelAlignment.wheels2.indexOf(activeStation.id) !== -1 ?
        2 : wheelAlignment.wheels4.indexOf(activeStation.id) !== -1 ?
            4 : 0;
    const wheelAlignmentPrice = !activeStation ? 0 : wheelAlignment.wheels2.indexOf(activeStation.id) !== -1 ?
        activeStation.expenses.wheelAlignment.wheels_2 : wheelAlignment.wheels4.indexOf(activeStation.id) !== -1 ?
            activeStation.expenses.wheelAlignment.wheels_4 : 0;

    const shippingPrice = activeStation
        ? activeStation.expenses.shipping
        : cart.expenses
            ? cart.expenses.shipping
            : -1;

    const loading = initialLoading || loadingStationPrices;
    const totalPrice = cart.totalToPayRaw || cart.totalToPay || 0;

    const shipments = cart.shipments || [];
    const discountInfo = cart.allDiscounts || [];
    let shippingTime = activeStation
        ? activeStation.shippingTime
        : cart.shippingTime;
    const shippingTimeSplit = shippingTime.split('-');

    shippingTime = shippingTime.indexOf('-') !== -1 && (shippingTimeSplit[0] === shippingTimeSplit[1])
        ? shippingTime.substring(shippingTime.indexOf('-') + 1)
        : shippingTime;

    const allItemsPrice = getPriceForAll(products);
    const totalPriceMatesRates = totalPrice - allItemsPrice / 2;

    let sidebarPostcode = checkout.addressShipping && checkout.addressShipping.shippingPostCode
        ? `${checkout.addressShipping.shippingState ? `${checkout.addressShipping.shippingState}, ` : ''}${checkout.addressShipping.shippingPostCode}`
        : (customerDefaultAddress
            ? `${customerDefaultAddress.state ? `${customerDefaultAddress.state}, ` : ''}${customerDefaultAddress.postcode}`
            : '');
    if (isMobileFitter) {
        let shippingState = localStorage.getItem('shippingState');
        shippingState = JSON.parse(shippingState)?.value;

        sidebarPostcode = localStorage.getItem('shippingPostcode');
        sidebarPostcode = JSON.parse(sidebarPostcode)?.value || '';
        sidebarPostcode = shippingState ? `${shippingState.toUpperCase()}, ${sidebarPostcode}` : sidebarPostcode;
    }
    setPaypalTotalPrice(totalPrice);
    const fittingStationAllowed = TYROOLA.initialFluxStates.products && TYROOLA.initialFluxStates.products.length > 0
        ? TYROOLA.initialFluxStates.products.filter(p => p.availableServices && p.availableServices.indexOf('fitting_cost') !== -1).length > 0
        : true;

    if ($(window).width() < 768) {
        const sidebarTotalTop = document.querySelector('#sidebar-total-top');
        const sidebarTop = document.querySelector('#sidebar-top');
        const sidebarTotalTopContent = [
            getTotalPriceRow({
                loading: loading,
                currencyIsoCode: options.currencyIsoCode,
                totalPrice: totalPrice,
            }),
        ];

        const productsQty = products.reduce((qty, product) => (isValidProduct(product) ? qty + parseInt(product.qty, 10) : qty + 1), 0);
        const sidebarTopContent = [
            getGoToCheckoutRow({
                fittingStationAllowed: fittingStationAllowed,
                hasFitting: !!activeStation,
                hasBorder: (fittingStationAllowed && (!activeStation || fittingNotAvailable)),
                baseUrl: options.baseUrl,
                qty: productsQty,
            }),
        ];

        sidebarTotalTop.innerHTML = ReactDOMServer.renderToString(<>{sidebarTotalTopContent}</>);
        sidebarTop.innerHTML = ReactDOMServer.renderToString(<>{sidebarTopContent}</>);

        document.addEventListener("scroll", () => {
            const isBtnVisible = isScrolledIntoView(document.querySelector('.go-to-checkout'));
            if (isBtnVisible) {
                sidebarTop.style.opacity = '0';
            } else {
                sidebarTop.style.opacity = '1';
            }
        });
    }

    return (
        <Cart
            products={products}
            allItemsPrice={allItemsPrice}
            currencyIsoCode={options.currencyIsoCode}
            fittingStationId={fittingStationId}
            fittingStationStreet={fittingStationStreet}
            fittingStationSuburb={fittingStationSuburb}
            sidebarPostcode={sidebarPostcode}
            fittingPrice={fittingPrice}
            calloutFeePrice={calloutFeePrice}
            wheelAlignmentQuantity={wheelAlignmentQuantity}
            wheelAlignmentPrice={wheelAlignmentPrice}
            fittingNotAvailable={fittingNotAvailable}
            fittingStationAllowed={fittingStationAllowed}
            hasFitting={!!activeStation}
            hasShipping={!!activeStation || shippingPrice !== -1}
            hasWheelAlignment={wheelAlignmentQuantity > 0}
            shippingPrice={shippingPrice}
            shippingTime={shippingTime}
            shipments={shipments}
            discountInfo={discountInfo}
            totalPrice={totalPrice}
            totalPriceMatesRates={totalPriceMatesRates}
            isMobileFitter={isMobileFitter}
            fsDetailsVisible={sidebar.fsDetailsVisible}
            loading={loading}
            baseUrl={options.baseUrl}
            onQuantityChange={onQuantityChange}
            onAddToCartClick={noop}
            onChangeStationClick={options.onChangeStationClick}
            onRemoveStationClick={options.onRemoveStationClick}
            onMoreInfoWheelAlignmentClick={onMoreInfoWheelAlignmentClick}
            onAddServiceFittingStationClick={options.onAddServiceFittingStationClick}
            onAddFittingServiceLearnMoreClick={options.onAddFittingServiceLearnMoreClick}
            onShowFsDetailsClick={showFsDetails}
            onFittingNotAvailableLearnMoreClick={bind(onFittingNotAvailableLearnMoreClick, fittingNotAvailable)}
            onMatesRatesLearnMoreClick={showFriendbuyLightBox}
            onShowProductDetailsClick={showProductDetails}
            onCalculate={show}
            isMpsProduct={false}
            cartProducts={cart.products}
            onRemoveDiscountClick={onRemoveDiscountClick}
        />
    );
}

const getOptions = options => ({
    ...options,
    onAddServiceFittingStationClick: onAddServiceFittingStationClickFactory(options.tyreType),
    onAddFittingServiceLearnMoreClick: onAddFittingServiceLearnMoreClickFactory(options.tyreType),
    onChangeStationClick: onChangeStationClickFactory(options.tyreType),
    onRemoveStationClick: onRemoveStationClickFactory(options.tyreType),
});

export const init = (container, options) => {
    // hideFsDetails(); Hides the fitting station details
    return handleView(stores, render, getOptions(options), container);
};

function onMoreInfoWheelAlignmentClick() {
    showAction();
    open('PDP Sidebar');
}

const isMapAvailable = () => {
    loadGoogleMapDependencies();
};

const onFittingNotAvailableLearnMoreClick = (fittingNotAvailable) => {
    if (fittingNotAvailable === true) {
        showFsfNotAvailableLightBox();
    }
};

function onAddServiceFittingStationClickFactory(tyreType) {
    return () => {
        if (tyreType === types.TYRE_MOTO) {
            openMotoFittingStationFinder();
        } else {
            isMapAvailable();
            TYROOLA.mapsInitiated.then(() => {
                if (tyreType === types.TYRE_CAR) {
                    LightboxActions.totalPagesChangeAction(FsfPages.WITHOUT_SUCCESS_NOTIFICATION);
                    openCarFittingStationFinder();
                }
            });
        }
    };
}

function onAddFittingServiceLearnMoreClickFactory(tyreType) {
    return () => {
        if (tyreType === types.TYRE_MOTO) {
            openMotoFittingStationFinder();
        } else {
            isMapAvailable();
            TYROOLA.mapsInitiated.then(() => {
                if (tyreType === types.TYRE_CAR) {
                    LightboxActions.totalPagesChangeAction(FsfPages.WITHOUT_SUCCESS_NOTIFICATION);
                    goToFsfPage(FittingStationFinderConstants.LIGHTBOX_PAGE_USAGE_DESCRIPTION);
                    openCarFittingStationFinder();
                }
            });
        }
    };
}

function onChangeStationClickFactory(tyreType) {
    return () => {
        onChangeStationClick(tyreType);
    };
}

function onRemoveStationClickFactory() {
    return () => {
        onRemoveStationClick();
    };
}

const onCrossSellClick = (e, obj) => {
    onCrossSellDetailsClick(obj);
};

function calculateStationTotalPrice(setPrice, activeStation, wheelAlignment) {
    let total = setPrice;
    const expenses = activeStation ? activeStation.expenses : null;
    const services = {
        fitting: !!activeStation,
        shipping: !!activeStation,
        wheels_2: !!activeStation && wheelAlignment.wheels2.indexOf(activeStation.id) !== -1,
        wheels_4: !!activeStation && wheelAlignment.wheels4.indexOf(activeStation.id) !== -1,
    };

    if (services.fitting) {
        total += expenses.fitting;
    }

    if (services.shipping) {
        total += expenses.shipping;
    }

    if (services.wheels_2) {
        total += expenses.wheelAlignment.wheels_2;
    }

    if (services.wheels_4) {
        total += expenses.wheelAlignment.wheels_4;
    }

    return total;
}

function onQuantityChange(event) {
    const qty = parseInt(event.target.value, 10);
    const id = ProductsStore.getState()[0].id;
    const { stations } = FittingStationStore.getState();
    const { activeStation } = ActiveStationStore.getState();

    updateProduct({ id, qty });

    if (activeStation && !stations.length) {
        fetchInitialStationAction({ id, qty });
    } else if (activeStation && stations.length) {
        loadStations(activeStation.postcode);
    }
}

async function onRemoveDiscountClick(data) {
    if (data) {
        try {
            lockUi();
            await onRemoveDiscount(data);
            CartActions.loadCartAction(true);
            unlockUi();
        } catch (e) {
            unlockUi();
        }
    }
}

const getGstInfo = [
    <div className="total-price__gst" key="sidebar-cart-gst">
        <Translation translationKey="include-gst" placeholder={{ TAX: TYROOLA.initialFluxStates.tax }} />
    </div>,
];

const getTotalPriceRow = (props) => (
    <div style={{ display: 'flex', 'justifyContent': 'space-between' }}>
        <TotalPrice
            totalPrice={props.totalPrice}
            currencyIsoCode={props.currencyIsoCode}
            loading={props.loading}
            key="TotalPrice"
            labelExtraChildren={getGstInfo}
        />
    </div>
);

const getGoToCheckoutRow = (props) => (
    <GoToCheckout
        fittingStationAllowed={!props.fittingStationAllowed}
        hasFitting={props.hasFitting}
        hasBorder={props.fittingStationAllowed && (!props.hasFitting || props.fittingNotAvailable)}
        label="sidebar-go-to-checkout-button-top"
        placeholder={{ ITEMS: `(${props.qty} item${props.qty > 1 ? 's' : ''})` }}
        baseUrl={props.baseUrl}
        key="GoToCheckout"
    />
);

const isScrolledIntoView = (elem) => {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var element = $(elem);
    if (element && element.offset() && element.offset().top) {
        var elemTop = element.offset().top;
        var elemBottom = elemTop + element.height();

        return ((elemTop < docViewBottom) && (elemTop >= docViewTop));
    }
    return false;
};

const isValidProduct = (product) => {
    return product
        && product.cartProductType !== 'cross_sell_product'
        && product.type !== 'tyre_stewardship'
        && product.type !== 'insurance'
        && product.type !== 'gift_card'
        && product.type !== 'accessory';;
};